import { AfterViewInit, Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: '[appBotaoVoltar]',
})
export class BotaoVoltarDirective implements OnInit, AfterViewInit {
  constructor(private location: Location, private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click')
  onClick() {
    this.location.back();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (window.history.length <= 1) {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
    }
  }
}
